require('./titleBox.scss');

//@vendors
const React = require('react');
const PropTypes = require('prop-types');

const TitleBox = ({
    title,
    titleModifier,
    subTitle,
    subTitleModifier,
    paragraph,
    paragraphModifier,
    dash,
    container,
}) => {
    const renderSubTitle = subTitle ? <div className={`title-box__subtitle${subTitleModifier}`}>{subTitle}</div> : null;

    const renderParagraph = paragraph ? (
        <div className={`title-box__paragraph${paragraphModifier}`}>{paragraph}</div>
    ) : null;

    return (
        <div className={`title-box title-box__container${container}`}>
            <div className={`title-box__title${titleModifier}`}>{title}</div>
            <span className={dash}></span>
            {renderSubTitle}
            {renderParagraph}
        </div>
    );
};

TitleBox.propTypes = {
    title: PropTypes.any.isRequired,
    titleModifier: PropTypes.string,
    subTitleModifier: PropTypes.string,
    paragraphModifier: PropTypes.string,
    container: PropTypes.string,
    paragraph: PropTypes.string,
    dash: PropTypes.string,
};

module.exports = TitleBox;
